import { createFileRoute } from '@tanstack/react-router'
import CostTypes from 'Admin/components/costtypes/CostTypes'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/costtypes')({
    component: () => (
        <Guard claims={['opus_user']}>
            <CostTypes />
        </Guard>
    ),
})
